import { styled } from '$utils/theme'
import { rem } from 'polished'
import { FormContainer } from '$views/components/FormContainer'

export const GreyBlock = styled.div`
  background-color: ${p => p.theme.colors.xlightGrey};
`

export const ContainerBlock = styled.div`
  max-width: ${p =>
    p.theme.media.desktop ? rem(p.theme.grid.contentMaxWidth.desktop) : rem(p.theme.grid.contentMaxWidth.mobile)};
  padding: ${p => rem(p.theme.sizes.mini)} ${p => rem(p.theme.sizes.mini)};
  margin-left: auto;
  margin-right: auto;
  position: relative;
`

export const StyledFormContainer = styled(FormContainer)`
  margin-top: 0;
`



// WEBPACK FOOTER //
// ./src/views/components/CaretakerCard/CaretakerCard.style.ts